import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ProblemSolutionSection from './components/ProblemSolutionSection';
import AdvantagesSection from './components/AdvantagesSection';
import VideoGallerySection from './components/VideoGallerySection';
import ServicesSection from './components/ServicesSection';
import SuitableForSection from './components/SuitableForSection';
import ProcessSection from './components/ProcessSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import ContactCTASection from './components/ContactCTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSolutionSection />
        <AdvantagesSection />
        <VideoGallerySection />
        <ServicesSection />
        <SuitableForSection />
        <ProcessSection />
        <TrustSection />
        <FAQSection />
        <ContactCTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}